import React from "react";
import {
  Segment,
  Form,
  TextArea,
  Popup,
  Button,
  Message,
  Radio,
} from "semantic-ui-react";
import "./styles.css";
export const OrderNote = ({
  radio,
  nCaracteresLetter,
  validWordsLetter,
  letter,
  changeNote,
  note,
  handleTextLetterChange,
  handleRadio,
}) => {
  const handleSetLocalStorage = (e) => {
    if (e.target.value !== "") {
      localStorage.setItem("dedicatoria", e.target.value);
      handleTextLetterChange(e);
    } else {
      localStorage.removeItem("dedicatoria");
      handleTextLetterChange(e);
    }
  };

  return (
    <Segment>
      <p className="mr-3 h5">
        Dedicatoria:{" "}
        <Popup
          content={`Solo puede agregar ${nCaracteresLetter} caracteres`}
          trigger={<Button circular icon="info" size="mini" color="grey" />}
        />
      </p>
      <Form>
        <TextArea
          placeholder="¿Qué mensaje desea que le escribamos a la tarjeta?"
          type="text"
          className="form-control"
          value={letter}
          onChange={(e) => handleSetLocalStorage(e)}
        />
      </Form>
      {validWordsLetter ? null : (
        <Message
          negative
          header="Se exedió el límite"
          content={`Sólo puede agregar un máximo de ${nCaracteresLetter} caracteres.`}
        />
      )}
      <div className="div-form-pp">
        <Form className="form-pp">
          <Form.Field>¿Colocamos tu nombre al final del mensaje?</Form.Field>
          <Form.Group style={{ paddingLeft: 8 }}>
            <Form.Field
              className="form-field-pp"
              style={{
                padding: 0,
              }}
            >
              <Radio
                label="Si"
                name="radioGroup"
                value="true"
                checked={radio === "true"}
                onChange={() => handleRadio("true")}
              />
            </Form.Field>
            <Form.Field className="form-field-pp">
              <Radio
                label="No"
                name="radioGroup"
                value="false"
                checked={radio === "false"}
                onChange={() => handleRadio("false")}
              />
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
      <Form>
        <p>Nota del pedido</p>
        <TextArea
          value={note}
          name="note"
          placeholder="¿Deseas hacernos saber algo más?"
          onChange={changeNote}
          className="form-control"
        />
      </Form>
    </Segment>
  );
};
